import { render, staticRenderFns } from "./BlackForSource.vue?vue&type=template&id=25135a58&scoped=true"
import script from "./BlackForSource.vue?vue&type=script&lang=js"
export * from "./BlackForSource.vue?vue&type=script&lang=js"
import style0 from "./BlackForSource.vue?vue&type=style&index=0&id=25135a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25135a58",
  null
  
)

export default component.exports